export default {
  assetScope: {
    title: 'Asset Usage Rules',
    ruleTab: 'Usage Rules',
    defaultTab: 'Default Policy',
    recycleTab: 'Recycle Bin',
    addRule: 'Add Store Asset Usage Rule',
    ruleName: 'Rule Name',
    shopName: 'Store Name',
    groupName: 'Store Group Name',
    targetName: 'Scope',
    matchType: 'Scope Type',
    matchShop: 'Specified Store',
    matchGroup: 'Specified Store Group',
    useType: 'Usage Method',
    isUsed: 'Usage Status',
    used: 'In Use',
    unused: 'Unused',
    createTime: 'Created At',
    deleteTime: 'Deleted At',
    action: 'Actions',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    restore: 'Restore',
    permanentDelete: 'Delete Permanently',
    addTitle: 'Add Asset Usage Rule',
    basicInfo: 'Basic Information',
    usageSection: 'Usage Method',
    editTitle: 'Edit Asset Usage Rule',
    viewTitle: 'View Asset Usage Rule',
    deleteTitle: 'Delete Asset Usage Rule',
    confirmDelete: 'Move this asset usage rule to the recycle bin?',
    confirmRestore: 'Restore this asset usage rule?',
    ruleNamePlaceholder: 'Enter a rule name',
    targetPlaceholder: 'Select a scope',
    remark: 'Remark',
    remarkPlaceholder: 'Enter a remark',
    save: 'Save',
    confirm: 'Confirm',
    select: 'Select',
    selectShop: 'Select Store',
    selectShopGroup: 'Select Store Group',
    searchName: 'Search by name or city',
    selected: 'Selected',
    shopCode: 'Store Code',
    shopStatus: 'Store Status',
    shopEnabled: 'Enabled',
    shopDisabled: 'Disabled',
    shopPending: 'Pending opening',
    shopPlanned: 'Planned opening',
    shopOperating: 'Operating',
    shopSuspended: 'Temporarily closed',
    shopClosed: 'Permanently closed',
    region: 'Region',
    city: 'City',
    ruleOccupancy: 'Rule Occupancy',
    usageAvailable: 'Available for rule',
    usageOccupied: 'Already has a rule',
    usageSelected: 'Selected by current rule',
    shopCount: 'Store Count',
    coveredShopCount: 'Covered Stores',
    shopUnit: 'stores',
    occupied: 'Occupied by another rule',
    defaultTitle: 'Default Policy',
    defaultDescription: 'When a member asset does not match a usage rule, its available scope is determined by the policy below.',
    policyRule: 'Available within rule scope',
    policyRuleDesc: 'The asset can be used in stores covered by the current rule.',
    policyTenant: 'Available across the tenant',
    policyTenantDesc: 'The asset can be used in all stores of the tenant.',
    policySource: 'Source store only',
    policySourceDesc: 'The asset can only be used in the store where it was created.',
    saveDefault: 'Save and Apply',
    switchDefaultTitle: 'Switch Default Policy',
    switchDefaultConfirmTitle: 'Confirm Default Policy Switch',
    currentDefaultPolicy: 'Current default usage',
    nextDefaultPolicy: 'Default usage after switch',
    switchEffective: 'Effect of this change',
    switchEffectiveNow: 'Effective immediately',
    manualRulePriority: 'Manual rules take priority',
    manualRulePriorityDesc: 'Only affects assets that do not match a manual rule',
    switchDefaultNotice: 'This change affects the available scope of existing and new assets from stores without manually configured rules. Please confirm before continuing.',
    confirmSwitch: 'Confirm Switch',
    loadFailed: 'Failed to load',
    selectRequired: 'Select a scope',
    nameRequired: 'Enter a rule name',
    removeSuccess: 'Moved to recycle bin',
    restoreSuccess: 'Restored successfully',
    saveSuccess: 'Saved successfully',
    noPermanentDelete: 'The permanent delete API is not available',
    shop: 'Store',
    group: 'Store Group',
  },
};
